module.exports = "/images/yoe-logo-big.png?ce5e44ebe14bf177b01fc8747128c95e";